import axios from 'axios'
import { API_ENDPOINT } from '../../../config'
import store from '../../../redux/stores/store'

const getDefaultState = () => {
    return {
        loading: false,
        deletingId: null,
        flightOffers: [],
        filter: {
            column: "",
            value: ""
        },
        selectedIndex: -1,
        currentPage: 1,
        pageSize: 50,
        total: 0
    }
}

const loadFlightOffers = instance => {
    instance.setState({ ...instance.state, loading: true })

    let criteria = {}
    if (instance.state.filter.column.length > 0 && instance.state.filter.value.length > 0) {
        criteria = {
            [instance.state.filter.column]: instance.state.filter.value
        }
    }

    axios({
        method: 'post',
        url: API_ENDPOINT + "/api/flights",
        headers : {
            "Authorization": store.getState().auth.authorization
        },
        data: {
            offset: (instance.state.currentPage - 1) * instance.state.pageSize,
            limit: instance.state.pageSize,
            criteria: criteria
        }
    }).then(response => handleLoadFlightOffersResponse(instance, response))
    .catch(error => alert(error))
}

const handleLoadFlightOffersResponse = (instance, response) => {
    if (response.data.status === 200) {
        instance.setState({
            ...instance.state,
            loading: false,
            flightOffers: response.data.data.flightOffers
        })
    }
    else if (response.data.status === 403) {
        instance.props.history.push('/auth/login')
    }
}

const FlightOffersWorker = instance => {
    const deleteFlightOffer = id => {
        instance.setState({ ...instance.state, deletingId: id })
        axios({
            method: 'post',
            url: API_ENDPOINT + "/api/flight/delete",
            headers : {
                "Authorization": store.getState().auth.authorization
            },
            data: {
                id: id
            }
        }).then(response => handleDeleteFlightOfferResponse(instance, response, id))
        .catch(error => alert(error))
    }

    const handleDeleteFlightOfferResponse = (instance, response, id) => {
        if (response.data.status === 200) {
            instance.setState({
                ...instance.state,
                deletingId: null,
                flightOffers: instance.state.flightOffers.filter((flightOffer) => flightOffer.id !== id)
            })
        }
        else if (response.data.status === 403) {
            instance.props.history.push('/auth/login')
        }
        else {
            instance.setState({
                ...instance.state,
                deletingId: null
            })
        }
    }

    return {
        loadFlightOffers: () => loadFlightOffers(instance),
        getDefaultState: () => getDefaultState(instance),
        deleteFlightOffer: (id) => deleteFlightOffer(id)
    }
}

export default FlightOffersWorker
